import i18n from '@/plugins/i18n';
import { DataTypes } from '@/utils/enums/dataTypes';

const osTypes = [
  {
    key: 'all',
    label: i18n.global.t('all'),
  },
  {
    key: 'IOS',
    label: i18n.global.t('ios'),
  },
  {
    key: 'ANDROID',
    label: i18n.global.t('android'),
  },
];

const crashTopLocationData = [
  {
    locationName: 'USA',
    noOfCrashes: '16',
    noOfAffectedUsers: '100',
    liveCrashes: '20',
    crashFreeUser: '12',
    data: [
      {
        locationName: 'Kansas',
        noOfCrashes: '16',
        noOfAffectedUsers: '100',
        liveCrashes: '20',
        crashFreeUser: '12',
      },
    ],
  },
  {
    locationName: 'INDIA',
    noOfCrashes: '36',
    noOfAffectedUsers: '30',
    liveCrashes: '12',
    crashFreeUser: '23',
    data: [
      {
        locationName: 'Bangalore',
        noOfCrashes: '16',
        noOfAffectedUsers: '100',
        liveCrashes: '20',
        crashFreeUser: '22',
      },
    ],
  },
];

const CrashInfoTableHeaders = () => [
  {
    key: 'crashName',
    name: i18n.global.t('crashName'),
    width: '29%',
    sortable: true,
    dataType: 'String',
    isEllipsisReq: true,
    enableEllipsis: true,
  },
  {
    key: 'crashEventsCount',
    name: i18n.global.t('crashEvents'),
    sortable: true,
    width: '27%',
    dataType: 'float',
    icon: 'browsingHistoryFilled',
    event: 'OnEventsClick',
  },
  {
    key: 'affectedUsers',
    name: i18n.global.t('noAffectedUsers'),
    sortable: true,
    width: '29%',
    dataType: 'float',
  },
  {
    key: 'lastOccurred',
    name: i18n.global.t('lastOccured'),
    sortable: true,
    width: '31%',
    dataType: DataTypes.TIME,
    defaultSortBy: true,
    defaultOrder: 'DES',
  },
];

const CrashTopLocationHeaders = () => [
  {
    key: 'countryName',
    name: i18n.global.t('country'),
    width: '34%',
    sortable: true,
    dataType: 'String',
  },
  {
    key: 'noOfCrashes',
    name: i18n.global.t('noOfCrashes'),
    sortable: true,
    width: '33%',
    dataType: 'float',
    defaultSortBy: true,
    defaultOrder: 'DES',
  },
  {
    key: 'noOfAffectedUsers',
    name: i18n.global.t('noAffectedUsers'),
    sortable: true,
    width: '33%',
    dataType: 'float',
  },
  // {
  //   key: 'liveCrashes',
  //   name: i18n.global.t('liveCrashes'),
  //   sortable: false,
  //   width: '15%',
  //   dataType: 'float'
  // },
  // {
  //   key: 'crashFreeUser',
  //   name: i18n.global.t('crashFreeUserPercentage'),
  //   sortable: false,
  //   width: '15%',
  //   dataType: 'float'
  // }
];

const appUsageKpis = () => [
  {
    keyLeft: 'users',
    labelLeft: i18n.global.t('newUsers'),
    iconNameLeft: 'user',
    iconHeightLeft: '2.75rem',
    iconWidthLeft: '2.75rem',
    keyRight: 'usersPerMin',
    labelRight: i18n.global.t('usersPerMin'),
    isFirstEle: true,
    tooltipText: i18n.global.t('tooltipTextNewUsers'),
  },
  {
    keyLeft: 'sessions',
    labelLeft: i18n.global.t('sessions'),
    iconNameLeft: 'clockOutlined',
    iconHeightLeft: '2.75rem',
    iconWidthLeft: '2.75rem',
    keyRight: 'sessionsPerMin',
    labelRight: i18n.global.t('sessionsPerMin'),
    tooltipText: '',
  },
  {
    keyLeft: 'launches',
    labelLeft: i18n.global.t('appLaunches'),
    iconNameLeft: 'arrowNE',
    iconHeightLeft: '2.75rem',
    iconWidthLeft: '2.75rem',
    keyRight: 'launchesPerMin',
    labelRight: i18n.global.t('launchesPerMin'),
    tooltipText: '',
  },
];

const appUsageDevices = {
  iosKey: 'iosKey',
  iosLabel: i18n.global.t('ios'),
  iosHeight: '3rem',
  iosWidth: '3rem',
  androidKey: 'androidKey',
  androidLabel: i18n.global.t('android'),
  androidHeight: '3rem',
  androidWidth: '2.75rem',
};

const crashKpis = () => [
  {
    keyLeft: 'totalNoOfCrashes',
    labelLeft: i18n.global.t('crashes'),
    redirectPathNameLeft: 'crashesGraphs',
    keyRight: 'crashesNpm',
    labelRight: i18n.global.t('crashesPerMin'),
  },
  {
    keyLeft: 'crashFreeUsersPercent',
    labelLeft: i18n.global.t('crashFreeUsers'),
    // below field is hidden
    // keyRight: 'liveCrashes',
    // labelRight: i18n.global.t('liveCrashes')
  },
];

const performanceKpis = () => [
  {
    keyLeft: 'numberOfRequest',
    labelLeft: i18n.global.t('noOfWebRequests'),
    iconNameLeft: 'webRequests',
    iconHeightLeft: '2.625rem',
    iconWidthLeft: '2.488rem',
    keyRight: 'httpResponse',
    labelRight: i18n.global.t('httpRespTimeWithoutUnit'),
    iconNameRight: 'browserOutlined',
    iconHeightRight: '2.5rem',
    iconWidthRight: '2.5rem',
  },
  {
    keyLeft: 'errorPercent',
    labelLeft: i18n.global.t('errorPercentageRate'),
    iconNameLeft: 'errorRate',
    redirectPathNameLeft: 'perfErrors',
    iconHeightLeft: '2.625rem',
    iconWidthLeft: '2.488rem',
    // below field is hidden
    // keyRight: 'avgLoadTime',
    // labelRight: i18n.global.t('avgLoadTime'),
    // iconNameRight: 'avgLoadTime',
    // iconHeightRight: '2.625rem',
    // iconWidthRight: '2.488rem'
  },
];

const httpInfoTableHeaders = () => [
  {
    key: 'endpointName',
    name: i18n.global.t('requestUrl'),
    width: '25%',
    sortable: true,
    dataType: 'String',
    isEllipsisReq: true,
    enableEllipsis: true,
  },
  {
    key: 'requestsPerMin',
    name: i18n.global.t('requests'),
    sortable: true,
    width: '30%',
    dataType: 'float',
    defaultSortBy: true,
    defaultOrder: 'DES',
  },
  {
    key: 'responseTime',
    name: i18n.global.t('responseTimeWithoutUnit'),
    sortable: true,
    width: '23%',
    dataType: 'float',
  },
  {
    key: 'errorRate',
    name: i18n.global.t('errorRate'),
    sortable: true,
    width: '22%',
    dataType: 'float',
  },
];

const PerformanceTopLocationHeaders = () => [
  {
    key: 'countryName',
    name: i18n.global.t('country'),
    width: '25%',
    sortable: true,
    dataType: 'String',
  },
  {
    key: 'noOfRequests',
    name: i18n.global.t('noOfRequests'),
    sortable: true,
    width: '25%',
    dataType: 'float',
    defaultSortBy: true,
    defaultOrder: 'DES',
  },
  {
    key: 'errorRatePercent',
    name: i18n.global.t('percentageErrorRate'),
    sortable: true,
    width: '23%',
    dataType: 'float',
  },
  {
    key: 'avgHttpResponseTime',
    name: i18n.global.t('httpRespTimeWithoutUnit'),
    sortable: true,
    width: '27%',
    dataType: 'float',
  },
];

const UsageTopLocationHeaders = [
  {
    key: 'countryName',
    name: i18n.global.t('country'),
    width: '34%',
    sortable: false,
    dataType: 'String',
  },
  {
    key: 'noOfCrashes',
    name: i18n.global.t('users'),
    sortable: false,
    width: '33%',
    dataType: 'float',
  },
  {
    key: 'noOfAffectedUsers',
    name: i18n.global.t('newUsers'),
    sortable: false,
    width: '33%',
    dataType: 'float',
  },
];

const TopUserActionsInfoTableHeaders = [
  {
    key: 'crashName',
    name: i18n.global.t('userAction'),
    width: '29%',
    sortable: false,
    dataType: 'String',
    isEllipsisReq: true,
  },
  {
    key: 'crashEventsCount',
    name: i18n.global.t('count'),
    sortable: false,
    width: '21%',
    dataType: 'float',
    icon: 'browsingHistoryFilled',
    event: 'OnEventsClick',
  },
  {
    key: 'affectedUsers',
    name: i18n.global.t('actioonPerMin'),
    sortable: false,
    width: '19%',
    dataType: 'float',
  },
  {
    key: 'lastOccurred',
    name: i18n.global.t('duration'),
    sortable: false,
    width: '31%',
    dataType: DataTypes.TIME,
  },
];

export {
  osTypes,
  appUsageKpis,
  CrashInfoTableHeaders,
  httpInfoTableHeaders,
  appUsageDevices,
  crashKpis,
  performanceKpis,
  crashTopLocationData,
  CrashTopLocationHeaders,
  PerformanceTopLocationHeaders,
  UsageTopLocationHeaders,
  TopUserActionsInfoTableHeaders,
};
